<template>
  <div id="how-i-work">
    <div class="section padding-top padding-bottom over-hide">
      <div class="container">
        <div class="row page-title px-4 px-xl-2">
          <div class="col-12 col-lg-6 padding-top-big">
            <div class="row">
              <div class="col-sm-2 text-right">
                <span> HOW I WORK</span>
              </div>
              <div class="col-sm-10 parallax-fade-top mb-5">
                <h1 class="no-break">
                  <span class="highlight">innovation</span> through<br />
                  <vue-typer
                    :text="['design', 'strategy', 'code']"
                    :repeat="Infinity"
                    :shuffle="true"
                    initial-action="erasing"
                    :pre-type-delay="70"
                    :type-delay="70"
                    :pre-erase-delay="2000"
                    :erase-delay="250"
                    erase-style="select-all"
                    :erase-on-complete="false"
                    caret-animation="smooth"
                  ></vue-typer>
                </h1>
              </div>
              <div class="offset-sm-2 col-sm-10 parallax-fade-top">
                <router-link to="/projects" class="h3 main-button" tag="a"
                  >see the results</router-link
                >
              </div>
            </div>
          </div>
          <div class="col-12 col-lg-6">
            <div class="img-fluid">
              <AnimalAnimation />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ParallaxEffect } from "@/components/utils";
import AnimalAnimation from "@/components/AnimalAnimation";
export default {
  components: {
    AnimalAnimation
  },
  mounted() {
    ParallaxEffect(this.$el);
  }
};
</script>

<style lang="scss" scoped>
/deep/ .vue-typer {
  color: #ffff;
  white-space: nowrap;

  .custom.char {
    &.typed {
      color: $primary;
    }

    &.selected {
      background-color: #009688;
    }
  }
}
</style>
